import { render, staticRenderFns } from "./shippingLabel1868.vue?vue&type=template&id=d8ec02f8&scoped=true&"
import script from "./shippingLabel1868.vue?vue&type=script&lang=js&"
export * from "./shippingLabel1868.vue?vue&type=script&lang=js&"
import style0 from "./shippingLabel1868.vue?vue&type=style&index=0&id=d8ec02f8&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d8ec02f8",
  null
  
)

export default component.exports